import { SUPPORTED_CURRENCIES } from "../utils/currency";

interface Props {
  id?: string;
  value: string;
  onChange: (v: string) => void;
  className?: string;
}

export function CurrencySelect({ id, value, onChange, className }: Props) {
  return (
    <select
      id={id}
      value={value}
      onChange={e => onChange(e.target.value)}
      className={className ?? "input"}
    >
      {SUPPORTED_CURRENCIES.map(c => (
        <option key={c.code} value={c.code}>{c.label}</option>
      ))}
    </select>
  );
}
